'use strict';

import { normalizarTema } from '@/design-system/theme/expand';

let cachedTheme = null;

async function fetchThemeJson() {
  const response = await fetch('/theme.json');

  if (!response.ok) {
    throw new Error(`Failed to load theme.json: ${response.status} ${response.statusText}`);
  }

  return response.json();
}

export async function loadTheme() {
  if (cachedTheme) {
    return cachedTheme;
  }

  // O CI copia a pasta do tenant (themes/<slug>/*) para public/ antes do build,
  // então este fetch pega o theme.json do tenant que foi compilado.
  // normalizarTema aceita os DOIS formatos: o legado passa intacto e o novo
  // (só marca) é expandido para a mesma forma. É o que permite migrar os
  // tenants um a um sem tocar em quem consome o tema.
  cachedTheme = normalizarTema(await fetchThemeJson());

  return cachedTheme;
}

export function getCachedTheme() {
  return cachedTheme;
}
